import { Card, MainDiv } from "../component";

import { faCode, faTachographDigital, faDatabase, faServer } from "@fortawesome/free-solid-svg-icons";
import { faConnectdevelop, faGoogleDrive } from "@fortawesome/free-brands-svg-icons";

import "../asset/style/Service.css";

function Service(){
    let service_info = [
      {
        header: "Custom Web Application",
        content:
          "I build custom web applications tailored to your business needs. Whether you need a simple web presence, a landing page, or a complex system with multiple user roles and features.",
        icon: faCode
      },
      {
        header: "API Development & Integration",
        content:
          "I specialize in developing secure, efficient, well-documented RESTful APIs, and integrating them into existing systems to enable seamless data flow and communication.",
        icon: faServer
      },
      {
        header: "Responsive Front-End Development",
        content: "I develop interactive, high-performance, and responsive user interfaces that ensure an optimal user experience, regardless of whether your customers are on desktop, tablet, or mobile.",
        icon: faTachographDigital
      },
      {
        header: "Database Design & Management",
        content: "Efficient data handling is crucial for any application. I offer services for designing, optimizing, and managing databases using MongoDB and/or MySQL, ensuring that your application scales smoothly with your growing business needs.",
        icon: faDatabase
      },
      {
        header: "Deployment and Maintenance",
        content: "After development, I take care of the deployment process on cloud platforms like Firebase, Vercel, Render, etc. ensuring your application is live and accessible. I also offer ongoing maintenance and updates to keep your app running smoothly and securely.",
        icon: faGoogleDrive
      },
      {
        header: "Third-Party Integrations:",
        content: "Need to integrate payment gateways, OAuth login, messaging platforms, or other APIs? I’ll ensure your app seamlessly connects with external services.",
        icon: faConnectdevelop
      }
    ];

    service_info= service_info.map((item)=>{
        return (<Card key={item.header} header={item.header} content={item.content} icon={item.icon} />);
    });
    
    return(
        <MainDiv>
            <h1>Services</h1>
            <p>As a seasoned <strong><abbr title="MongoDB, Express.js, React, Node.js">MERN</abbr> Stack developer</strong>, I specialize in designing, building, and maintaining powerful, dynamic applications. I handle every aspect of the development process, from back-end to front-end, ensuring seamless performance, robust architecture, and responsive user interfaces.</p>
            <div className="service_card">
                {service_info}
            </div>
        </MainDiv>
    );
}

export default Service;